import { render, staticRenderFns } from "./ListContactSubjects.vue?vue&type=template&id=2929e20b&scoped=true"
import script from "./ListContactSubjects.vue?vue&type=script&lang=js"
export * from "./ListContactSubjects.vue?vue&type=script&lang=js"
import style0 from "./ListContactSubjects.vue?vue&type=style&index=0&id=2929e20b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2929e20b",
  null
  
)

export default component.exports